<template>

  <BaseLayout

    :panels="panels"

    :padding="8"

    :gutter="8"

    style="background: #eef4fc;"

  />

</template>



<script>

import {buildBidDashboardPanels} from '@/components/panel/bid-dashboard-layout';



export default {

  routerOption: {

    as_default: true,

  },

  computed: {

    windowWidth() {

      return this.$store.getters['session/windowWidth'];

    },

    panels() {

      return buildBidDashboardPanels(this.windowWidth);

    },

  },

};

</script>

